(function () {
  function initFaqSection(section) {
    if (section.dataset.faqInit === 'true') return;
    section.dataset.faqInit = 'true';

    var singleOpen = section.dataset.singleOpen === 'true';
    if (!singleOpen) return;

    var items = section.querySelectorAll('.b2b-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.b2b-faq').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.b2b-faq');
    if (section) initFaqSection(section);
  });
})();
